import type { SearchHit } from '~/types/sammy/response';
import { useProductSectionPath } from '~/composables/useProductSectionPath';
import { buildProductDetailPath } from '~/utils/buildProductDetailPath';
import { buildLocalizedPath } from '~/utils/buildLocalizedPath';
import { stripStoryblokPathPrefix } from '~/utils/stripStoryblokPathPrefix';

export const buildPreviewLink = (searchResult: SearchHit, countryLanguageSegment: string, lang: string) => {
    const productSectionPath = useProductSectionPath();
    const invalidFallback = '__INVALID__';

    switch (searchResult._index) {
        case 'document':
            return productSectionPath.value !== null
                ? `${buildProductDetailPath(
                      countryLanguageSegment,
                      productSectionPath.value,
                      slugify(
                          searchResult._source.censhare_product_name?.[lang] ||
                              searchResult._source.censhare_product_name?.default ||
                              invalidFallback
                      )
                  )}#Downloads`
                : invalidFallback;
        case 'product':
            return productSectionPath.value !== null
                ? buildProductDetailPath(
                      countryLanguageSegment,
                      productSectionPath.value,
                      slugify(
                          searchResult._source.censhare_name?.[lang] ||
                              searchResult._source.censhare_name?.default ||
                              invalidFallback
                      )
                  )
                : invalidFallback;
        case 'storyblok': {
            if (!searchResult._source.storyblok_country) return invalidFallback;
            const countryConfig = useCountryLanguages()[searchResult._source.storyblok_country];
            if (!countryConfig) return invalidFallback;

            const storyPath =
                searchResult._source.storyblok_translated_slugs?.[lang] ||
                (lang === countryConfig.defaultLanguage ? searchResult._source.storyblok_slug : undefined);
            if (!storyPath) return invalidFallback;

            const storyCountry = searchResult._source.storyblok_country;
            const storySlug = stripStoryblokPathPrefix(storyPath, storyCountry, lang);
            return storySlug === null ? invalidFallback : buildLocalizedPath(storyCountry, lang, storySlug);
        }
        default:
            console.warn('search result link could not be build with index:', searchResult._index);
            return invalidFallback;
    }
};
